<template>
  <ax-dialog
    ref="dialog"
    :title="`Editing decline parameters for ${well_api}`"
    icon="mdi-chart-bell-curve"
    tooltip="Edit decline parameters"
    size="large"
    persistant  
    :disabled="disabled"
    @submitted="onSave"
    @shown="onShow"
  >
    <template slot="content">
      <v-card-text v-if="params">
        <v-row>
          <v-col cols="8">
            <vue-plotly
              v-if="profile.data.length > 0"
              :data="profile.data"
              :layout="profile.layout"
              :options="profile.options"
            />
            <v-slider
              label="Duration (months)"
              v-model="duration.value"
              :min="duration.min"
              :max="duration.max"
              step="12"
              thumb-label
            />
          </v-col>
          <v-col cols="4">
            <div class="d-flex text-h6">
              <span>EUR</span>
              <v-spacer/>
              <span>{{ eur | numberFormat }}</span>
            </div>
            <p>Declined forecast for {{ duration.value }} months</p>
            <v-text-field type="number" prefix="qi =" @mousewheel="params[`ip_${method}_${target}`] += $event.deltaY" v-model.number="params[`ip_${method}_${target}`]" label="Initial production"></v-text-field>
            <v-text-field type="number" prefix="Di =" @mousewheel="params[`dr_${method}_${target}`] += $event.deltaY/10000" v-model.number="params[`dr_${method}_${target}`]" label="Initial decline"></v-text-field>
            <v-text-field type="number" prefix="b ="  @mousewheel="params[`c_${method}_${target}`]  += $event.deltaY/10000" v-model.number="params[`c_${method}_${target}`]" label="Hyperbolic exponent"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </template>
    <template v-slot:submit_text>
      Save
    </template>
  </ax-dialog>
</template>
<script>
import AxDialog from "@/components/dialog"
import DucsPermits from '@/api/ducspermits'
import VuePlotly from '@statnett/vue-plotly'
import * as F from "@/modules/forecast"
export default {
  name: "dlgEditParams",
  props: {
    item: { type: Object, required: true },
    well: { type: Object, required: true },
    disabled: { type: Boolean, default: false }
  },
  components: {
    AxDialog, VuePlotly
  },
  data() {
    return {
      predictions: null,
      params: null,
      features: null,
      decline: [],
      duration: {
        min: 0, 
        max: 600, 
        value: 600
      },
      target: 'oil',
      method: 'multi3a',
      menu: false,
      profile: {
        data: [],
        layout: {
          autosize: true,
          height: 250,
          legend: { x: 1, y: 1, xanchor: "right" },
          font: { family: "Roboto, sans-serif", color: '#808080' },
          hovermode: "closest",
          margin: { l: 70, t: 15, r: 15, b: 45 },
          xaxis: { title: { text: `Time (months)` }, dtick: 12 },
          yaxis: { title: { text: `Predicted Production` }, type: "log" },
          paper_bgcolor: "rgba(0,0,0,0)",
          plot_bgcolor: "rgba(0,0,0,0)"
        },
        options: { displayModeBar: false, responsive: true }
      }
    }
  },
  watch: {
    "duration.value": function() {
      this.setDecline()
    },
    "params": {
      handler() {
        Object.entries(this.params).forEach(([k,v]) => {
          if (k.includes('ip')) {
            this.params[k] = this.roundNumber(v, 0)
          } else {
            this.params[k] = this.roundNumber(v)
          }
        })
        this.setDecline()
        this.plotDecline()
      },
      deep: true
    }
  },
  computed: {
    well_api() {
      return this.well[this.item.config.api]
    },
    eur() {
      if (this.params) {
        return this.sum(this.decline)
      }
      return 0
    }
  },
  methods: {
    onShow(visible) {
      this.profile.data = []
      if (visible) {
        DucsPermits.getWell(this.item.uuid, this.well_api, { frame: 'predictions', target: 'oil', method: 'multi3a' }).then(response => {
          this.predictions = response.data
          this.plotPredictions()
        })
        DucsPermits.getWell(this.item.uuid, this.well_api, { frame: 'params' }).then(response => {
          this.params = JSON.parse(response.data)[0]
          this.setDecline()
          this.plotDecline()
        })
      }
    },
    onSave() {
      let payload = {
        target: this.target,
        method: this.method,
        action: 'params',
        params: this.params,
      }
      DucsPermits.patch(this.item.uuid, this.well_api, payload).then(_ => {
        this.$refs.dialog.show = false
        this.$emit("submitted")
      })
    },
    setDecline() {
      this.decline = F.declineWell(this.duration.value, this.params[`ip_${this.method}_${this.target}`], this.params[`dr_${this.method}_${this.target}`], this.params[`c_${this.method}_${this.target}`])
    },
    plotPredictions() {
      this.profile.data = this.profile.data.filter(x => x.name != 'Predictions')
      this.profile.data.push({
        name: 'Predictions',
        type: "bar",
        x: this.create_array(1, 12),
        y: this.predictions,
      })
    },
    plotDecline() {
      this.profile.data = this.profile.data.filter(x => x.name != 'Decline')
      this.profile.data.push({
        name: 'Decline',
        type: "scatter",
        mode: 'lines',
        x: this.create_array(1, 36),
        y: this.decline,
        line: { shape: 'spline', dash: 'solid', width: 1, color: 'red' },
      })
    }
  },
}
</script>